/**
 * The type of Redux action which sets the pending notification UID
 * to use it when hiding the notification is necessary, or unset it when
 * undefined (or no param) is passed.
 *
 * {
 *     type: SET_CURRENT_NOTIFICATION_UID,
 *     uid: ?number
 * }
 */
export const SET_NO_AUDIO_SIGNAL_NOTIFICATION_UID =
  'SET_NO_AUDIO_SIGNAL_NOTIFICATION_UID';
